export const APP_ORIGIN = 'https://app.eastensocial.com';
export const PUBLIC_ORIGIN = 'https://eastensocial.com';

export function initialSiteScreen(location) {
  const params = new URLSearchParams(location.search);
  if (['facebook', 'instagram', 'google', 'provider'].some((key) => params.has(key))) return 'dashboard';

  const hash = location.hash.replace('#', '');
  if (['login', 'signup', 'dashboard', 'admin', 'builder', 'calendar-public', 'privacy', 'terms', 'careers', 'disclaimer', 'contact', 'about'].includes(hash)) return hash;
  return location.hostname === 'app.eastensocial.com' ? 'login' : 'landing';
}
